import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { BookedTrip, Flight } from '@ibe/models';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../store';
import * as moment from 'moment';
import { BookedTripEffect } from 'src/app/effects';

@Component({
	selector: 'app-price-breakdown',
	templateUrl: './price-breakdown.component.html',
	styleUrls: ['./price-breakdown.component.scss']
})
export class PriceBreakdownComponent implements OnInit, OnDestroy {
	private isAlive = true;

	// Data
	bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	booked_trip: BookedTrip;
	flights: Flight[];
	environment = environment;

	items_summary = [];

	total_summary = 0;

	total_passengers: number;

	passengers: Array<string>;

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		private store: Store<fromStore.State>,
		private bookedTripEffect: BookedTripEffect
	) {


		this.bookedTrip$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {

				if (value) {
					this.booked_trip = value;
					this.flights = value.flights;

					this.total_passengers = value.flights.reduce((acc, cur) => acc += cur.passengerInfo.length, 0);

					const shoppingCart = this.bookedTripEffect.createShoppingCart(value);
					this.items_summary = shoppingCart.flights;
					this.total_summary = shoppingCart.summary.reduce((acc, cur) => acc += parseFloat(cur.value), 0);
				}

				this.passengers = Object.keys(this.booked_trip.passengers);
			});


	}

	getSumlItem(value) {
		return parseFloat(this.items_summary.filter(cur => cur.item == value).reduce((acc, cur) => acc += cur.value, 0)).toFixed(2);
	}

	ngOnInit() {

	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	TAP_printFlightDate(flight): string {
		if (flight) {
			const date = moment(new Date(flight.departure.time));
			return date.format('ddd DD MMM h:mm').toLocaleLowerCase();
		}
	}


	TAP_handleFareAndTaxes() {
		this.sidebarService.openSidebar(['fare-and-taxes']);
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	/** Handles close action intention **/
	TAP_handleClose() {
		this.closeSidebar();
	}

	TAP_filterItemsSummary(items) {
		return items.filter(cur => !['tickets', 'taxes'].includes(cur.item));
	}
}
